import styled from 'styled-components';
const percentageSize = 1.3;

export const SFCMenuItemContainer = styled.div`
  display: ${({ show }) => (show ? 'flex' : 'none')};
  padding: 0px;
  margin: 0.2em;
  margin-bottom: 20px;
`;

export const ItemImage = styled.img`
  width: 80px;
  height: 80px;
  cursor: pointer;
  border: ${({ selected }) => (selected ? '5px solid #febf00' : '0px solid transparent')};
  border-radius: 5px;
  opacity: 100%;

  //tablet
  @media screen and (max-width: 1023px) {
    height: 80px;
    width: 80px;
  }

  //mini-tablet || mobile rotated
  @media screen and (max-width: 768px) {
    height: 75px;
    width: 75px;
  }

  //mobile
  @media screen and (max-width: 464px) {
    height: 75px;
    width: 75px;
  }
`;

export const ItemInfo = styled.article`
  text-align: left;
  text-decoration: none;
  margin-left: 1em;
  margin-right: 5px;
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;

  //tablet
  @media screen and (max-width: 1023px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 20 * percentageSize : 20)}px;
  }

  //mobile
  @media screen and (max-width: 464px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 20 * percentageSize : 20)}px;
  }
`;

export const ItemInfoHeader = styled.h1`
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  margin: 0;
  cursor: pointer;
  font-weight: bold;

  //mini-tablet || mobile rotated
  @media screen and (max-width: 768px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 20 * percentageSize : 20)}px;
  }

  //mobile
  @media screen and (max-width: 464px) {
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 16 * percentageSize : 16)}px;
  }
`;

export const ItemInfoData = styled.div`
  width: 350px;
  display: flex;
  align-items: flex-end;
  gap: 20px;
  font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  margin: 0;
  white-space: pre-line;
  font-weight: 200;

  @media screen and (max-width: 768px) {
    width: 90%;
    margin-top: 5px;
    font-size: ${({ fontSizeEnabled }) => (fontSizeEnabled ? 12 * percentageSize : 12)}px;
  }
`;

export const ItemInfoOpacity = styled.div``;
export const ItemURL = styled.div`
  cursor: pointer;
`;
export const ItemA = styled.a`
  display: flex;
  text-decoration: none;
  color: white;
  gap: 5px;
  align-items: flex-start;
  &:hover {
    color: white;
  }
  &:visited {
    color: white;
  }
`;
export const TitleWrapper = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;
export const ExpandShrink = styled.button`
  background: none;
  border: none;
`;
